Vue.component("user-setting-component", require("./setting/Index.vue").default);
Vue.component(
  "user-setting-edit-component",
  require("./setting/Edit.vue").default
);
Vue.component(
  "user-setting-password-component",
  require("./setting/Password.vue").default
);
